/**
 * Derive up-to-2-letter initials from a display name for the avatar circle.
 *
 * Extracted from `TopBar`'s original inline computation during the
 * bottom-of-sidebar persona relocation so the null-handling (missing /
 * empty `displayName` → `'?'`) can't drift between the two call sites.
 */
export const getInitials = (displayName?: string | null): string =>
  displayName
    ? displayName
        .split(' ')
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : '?';
